import Vue from './directives';
import {BigNumber} from 'bignumber.js';

type LocalDef = 'zh' | 'en';
const isNumber = function (number: string): boolean {
    return /^-?[0-9]+.?[0-9]*$/.test(number);
};
const isEmpty = function (val: any): boolean {
    return val === undefined || val === null;
};
/**形如 150,678 */
Vue.filter('fixMoney', (value: any) => {
    if (!isNumber(value) || isEmpty(value)) {
        value = 0;
    }
    return new BigNumber(value).toFormat();
});
Vue.filter('fixPiece', (value: any) => {
    if (!isNumber(value) || isEmpty(value)) {
        value = 0;
    }
    return new BigNumber(value).toFormat(2);
});
Vue.filter('product_type', function (value: any) {
    value = value ? value.toString() : '';
    const list = value ? value.split(',') : [];
    const listName: any[] = [];
    for (let i = 0; i < list.length; i++) {
        let text = '';
        switch (parseInt(list[i])) {
            case 1:
                text = '梭织';
                break;
            case 2:
                text = '针织';
                break;
            default:
                text = '';
                break;
        }
        if (text) {
            listName.push(text);
        }
    }
    return listName.join(',');
});
Vue.filter('order_type', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = '纯加工';
            break;
        case 2:
            text = '包工包料(经销)';
            break;
        default:
            text = '';
    }
    return text;
});
Vue.filter('quote_order_type', function (value: any, local: any) {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 1:
                    text = '加工单';
                    break;
                case 2:
                    text = '经销单';
                    break;
                default:
                    text = '';
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 1:
                    text = 'processing of supply material';
                    break;
                case 2:
                    text = 'purchase order';
                    break;
                default:
                    text = '';
            }
            break;
    }
    return text;
});
Vue.filter('quote_state', function (value: any, local: any) {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 1:
                    text = '价格待确认';
                    break;
                case 2:
                    text = '价格确认';
                    break;
                case 3:
                    text = '已过期';
                    break;
                default:
                    text = '';
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 1:
                    text = 'waiting';
                    break;
                case 2:
                    text = 'confirm';
                    break;
                case 3:
                    text = 'expire';
                    break;
                default:
                    text = '';
            }
            break;
    }
    return text;
});
Vue.filter('shipmentKind', function (value: any, local: any) {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 1:
                    text = '送货单';
                    break;
                case 2:
                    text = '结算明细';
                    break;
                case 3:
                    text = '发票';
                    break;
                case 4:
                    text = '付款凭证';
                    break;
                case 5:
                    text = '进仓单';
                    break;
                default:
                    text = '';
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 1:
                    text = '送货单';
                    break;
                case 2:
                    text = '结算明细';
                    break;
                case 3:
                    text = '发票';
                    break;
                case 4:
                    text = '付款凭证';
                    break;
                case 5:
                    text = '进仓单';
                    break;
                default:
                    text = '';
            }
            break;
        default:
            switch (parseInt(value)) {
                case 1:
                    text = '送货单';
                    break;
                case 2:
                    text = '结算明细';
                    break;
                case 3:
                    text = '发票';
                    break;
                case 4:
                    text = '付款凭证';
                    break;
                case 5:
                    text = '进仓单';
                    break;
                default:
                    text = '';
            }
    }
    return text;
});
Vue.filter('guaranteeMoney', function (value: any) {
    let text = 0;
    if (!isNaN(parseInt(value))) {
        text = parseInt(value) * 3000;
    }
    return text;
});
Vue.filter('guaranteeAccount', function (value: any) {
    let text = 0;
    if (!isNaN(parseInt(value))) {
        text = parseInt(value) * 5 / 3;
    }
    return text;
});
Vue.filter('guaranteeEdu', function (value: any) {
    let text = 0;
    if (!isNaN(parseInt(value))) {
        text = parseInt(value) * 50 * 10000;
    }
    return text;
});
Vue.filter('isAvailable', function (value: any) {
    let text = '已过期';
    if (value) {
        text = '使用中';
    }
    return text;
});

Vue.filter('guaranteeState', function (value: any, payType: number, local: 'zh' | 'en') {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 1:
                    if (payType === 2) {
                        text = '提交成功';
                    } else {
                        text = '等待汇款';
                    }
                    break;
                case 2:
                    text = '等待确认';
                    break;
                case 3:
                    text = '支付成功';
                    break;
                case 4:
                    text = '支付失败';
                    break;
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 1:
                    if (payType === 2) {
                        text = '提交成功';
                    } else {
                        text = 'Wait for payment';
                    }
                    break;
                case 2:
                    text = ' waiting confirm payment';
                    break;
                case 3:
                    text = 'SUCCESS';
                    break;
                case 4:
                    text = 'FAILURE';
                    break;
            }
            break;
    }
    return text;
});
Vue.filter('quote_price_state', function (value: any, local: 'zh' | 'en') {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 1:
                    text = '价格确认';
                    break;
                case 2:
                    text = '价格放弃';
                    break;
                default:
                    text = '';
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 1:
                    text = 'confirm';
                    break;
                case 2:
                    text = 'give up';
                    break;
                default:
                    text = '';
            }
            break;
    }
    return text;
});
Vue.filter('currencyUnit', function (value: any, local: LocalDef) {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 1:
                    text = '元';
                    break;
                case 2:
                    text = '美元';
                    break;
                case 3:
                    text = '欧元';
                    break;
                default:
                    text = '';
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 1:
                    text = '￥ RMB';
                    break;
                case 2:
                    text = '$ USD DOLLAR';
                    break;
                case 3:
                    text = '€ Euro';
                    break;
                default:
                    text = '';
            }
            break;
    }
    return text;
});
Vue.filter('chooseSupplier', function (value: any, local: LocalDef) {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 1:
                    text = '所有的';
                    break;
                case 2:
                    text = '加工厂';
                    break;
                case 3:
                    text = '贸易公司';
                    break;
                case 4:
                    text = '指定供应商';
                    break;
                default:
                    text = '';
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 1:
                    text = 'all';
                    break;
                case 2:
                    text = 'only Manufacturer';
                    break;
                case 3:
                    text = 'only trading company';
                    break;
                case 4:
                    text = 'nominated supplier';
                    break;
                default:
                    text = '';
            }
            break;
    }
    return text;
});

Vue.filter('factory_state', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = '没有';
            break;
        case 2:
            text = '审核中';
            break;
        case 3:
            text = '通过';
            break;
        default:
            text = '';
    }
    return text;
});

Vue.filter('contractType', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = '服装销售合同';
            break;
        case 2:
            text = '加工单服装销售合同';
            break;
        case 3:
            text = '经销单服装销售合同';
            break;
        default:
            text = '';
    }
    return text;
});
Vue.filter('tradeRoleNum', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case -1:
          text='负值';
          break;
        case 0:
            text = 'boss';
            break;
        case 1:
            text = '经理';
            break;
        case 2:
            text = '业务员';
            break;
        case 3:
            text = '跟单员';
            break;
        case 9:
            text = '打样主管';
            break;
        case 10:
            text = '单证员';
            break;
        case 11:
            text = '财务';
            break;
        case 12:
            text = '财务&单证';
            break;
        case 13:
            text = '业务组长';
            break;
        case 14:
            text = '业务科长';
            break;
        case 15:
            text = '研发部';
            break;
        case 16:
            text = '面料主管';
            break;
        case 17:
            text = '面料QC';
            break;
        case 18:
            text = '辅料主管';
            break;
        case 19:
            text = 'QA';
            break;

        case 20:
            text = '版房助理';
            break;
        case 21:
            text = '版师';
            break;
        case 22:
            text = '打样员';
            break;
        case 23:
            text = '打样间裁剪';
            break;
        case 24:
            text = '业务经理';
            break;

        case 25:
            text = '采购员';
            break;
        case 26:
            text = '技术人员';
            break;
        case 27:
          text = '打样间缝制';
          break;
        case 28:
          text = '打样间后道';
          break;
      case 30:
        text = '工厂裁剪';
        break;
      case 31:
        text ='工厂缝制';
        break;
      case 32:
        text ='车间收发员';
        break;
      case 33:
        text ='生产厂长';
        break;
      case 34:
        text ='仓库员';
        break;
      case 35:
        text ='工厂后道';
        break;
      case 36:
        text ='裁剪主管';
        break;
        default:
            text = '';
    }
    return text;
});


Vue.filter('stuffUnitType', function (value: any) {


    const unitArray = [{value: 0, name: '米'}, {value: 1, name: 'kg'}, {value: 2, name: '码'}, {
        value: -2,
        name: '个',
    }, {value: -3, name: '条'}, {value: -4, name: '只'}, {value: -5, name: '套'}, {value: -6, name: '件'}];

    let str = '未确定';
    for (let i = 0; i < unitArray.length; i++) {
        if (parseInt(value) === unitArray[i].value) {
            str = unitArray[i].name;
        }
    }
    return str;
});


Vue.filter('extraTypeName', function (value: any) {


    let text = '';
    switch (parseInt(value)) {
        case 0:
            text = '胶袋';
            break;
        case 1:
            text = '纸箱';
            break;
        case 2:
            text = '材料';
            break;

        default:
            text = '';
    }
    return text;
});
Vue.filter('formItemTypeName', function (value: any) {


    const itemTypeArray = [{value: 1, name: '面料'}, {value: 2, name: '缝制辅料'}, {value: 3, name: '后道辅料'}, {
        value: 4,
        name: '工序',
    }, {value: 5, name: '杂费'}, {value: 6, name: '加工费'}, {value: 10, name: '特殊材料'}];
    let str = '未确定';
    for (let i = 0; i < itemTypeArray.length; i++) {
        if (parseInt(value) === itemTypeArray[i].value) {
            str = itemTypeArray[i].name;
        }
    }
    return str;
});

Vue.filter('stuffTypeName', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = '面料';
            break;
        case 2:
            text = '辅料';
            // text = '缝制辅料';
            break;
        case 3:
            text = '辅料';
            // text = '包装辅料';

            break;

        default:
            text = '';
    }
    return text;
});
Vue.filter('commission_type1', function (value: any) {
    const money = Math.round(value * 100 * 19 / 10000) / 100;
    return money;
});
Vue.filter('commission_type2', function (value: any) {
    const money = Math.round(value * 100 / 1000) / 100;
    return money;
});
Vue.filter('moneyPer', function (value: any) {
    const money = value / 100;
    return money;
});

Vue.filter('trade', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = 'fob';
            break;
        case 2:
            text = 'ddp/ldp';
            break;
        default:
            text = '';
            break;
    }
    return text;
});
import {formatDate} from './formatDate';

Vue.filter('date', function (value: any, type: string) {
    return formatDate(new Date(value), type);
});
Vue.filter('guaranteeEndTime', function (value: any, type: string) {
    let text = '等待汇款';
    if (value) {
        const startTime = new Date(value);
        startTime.setFullYear(startTime.getFullYear() - 1);
        text = formatDate(startTime, type) + '  至  ' + formatDate(new Date(value), type);
    }
    return text;
});

Vue.filter('order_state', function (value: any, local: LocalDef) {
    let text = '';
    switch (local) {
        case 'zh':
            switch (parseInt(value)) {
                case 0:
                    text = '待开启';
                    break;
                case 1:
                    text = '待签合同';
                    break;
                case 2:
                    text = '待付佣金';
                    break;
                case 3:
                    text = '处理中';
                    break;
                case 4:
                    text = '完成';
                    break;
                default:
                    text = '';
            }
            break;
        case 'en':
            switch (parseInt(value)) {
                case 0:
                    text = 'waiting open';
                    break;
                case 1:
                    text = 'waiting sign a contact';
                    break;
                case 2:
                    text = 'waiting pay commission';
                    break;
                case 3:
                    text = 'handling';
                    break;
                case 4:
                    text = 'finished';
                    break;
                default:
                    text = '';
            }
            break;
    }
    return text;
});

Vue.filter('orderInsurance', function (value: any, local: LocalDef) {
    let text = '无';
    if (value) {
        text = '保障中';
    }
    return text;
});
Vue.filter('questionLevel', function (value: any, local: LocalDef) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = '轻微';
            break;
        case 2:
            text = '中等';
            break;
        case 3:
            text = '严重';
            break;
        case 4:
            text = '极其严重';
            break;
        default:
            text = '';
    }
    return text;
});
Vue.filter('serviceApplyKind', function (value: any, local: LocalDef) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = '法律咨询服务';
            break;
        case 2:
            text = '征信调解服务';
            break;
        case 3:
            text = '供应商信用举报';
            break;
        default:
            text = '';
    }
    return text;
});
Vue.filter('serviceApplyState', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case 0:
            text = '待受理';
            break;
        case 1:
            text = '受理中';
            break;
        case 2:
            text = '已结束';
            break;
        default:
            text = '';
    }
    return text;
});
Vue.filter('serviceIncrementKind', function (value: any, local: LocalDef) {
    let text = '';
    switch (parseInt(value)) {
        case 1:
            text = '合同审阅';
            break;
        case 2:
            text = '发律师函';
            break;
        case 3:
            text = '诉讼';
            break;
        case 4:
            text = '网络视频讲座';
            break;
        case 5:
            text = '线下讲座';
            break;
        case 6:
            text = '国际企业信用报告';
            break;
        default:
            text = '';
    }
    return text;
});
Vue.filter('serviceIncrementState', function (value: any) {
    let text = '';
    switch (parseInt(value)) {
        case 0:
            text = '待付款';
            break;
        case 1:
            text = '待受理';
            break;
        case 2:
            text = '受理中';
            break;
        case 3:
            text = '已结束';
            break;
        default:
            text = '';
    }
    return text;
});


Vue.filter('changeType', function (value: any) {
    let str = '';
    if (value == 0) {
        str = '发货';
    }
    if (value == 1) {
        str = '退货';
    }
    if (value == 2) {
        str = '使用';
    }
    if (value == 3) {
        str = '转移';
    }

    return str;

});
Vue.filter('numberInt', function (value: any) {


    const toFixedNum = Number(value).toFixed(2);
    const realVal = toFixedNum.substring(0, toFixedNum.toString().length - 3);

    return realVal;

});
Vue.filter('numberFloat', function (value: any,number:number) {


    const fixNumber=number>0?number:2;
    const toFixedNum = Number(value).toFixed(fixNumber);
    const realVal = toFixedNum.substring(0, toFixedNum.toString().length);

    return realVal;

});
/*这个保留小数位数不能和编辑input一同使用，因为这种是无法输入 xxx.00这种数据的*/
Vue.filter('accurateToPoint', function (value: any, number: number) {

    const point = number > 0 ? number : 0;
    if (point > 0) {
        const roundValue = Math.round(parseFloat(value) * Math.pow(10,point));
        const value2 = roundValue / Math.pow(10,point);
        return value2;
    } else {
        return Math.round(parseFloat(value));
    }


});

Vue.filter('minusZero', function (value: any) {

  if(value<0){
    return 0;
  }else{
    return value;
  }
});
Vue.filter('hideZero', function (value: any) {
    if(value==0) {
        return '';
    }else{
        return value;
    }
});
Vue.filter('deliveryLoginMulName', function (value: any) {
  let str = '';
  if (value == 0) {
    str = '补';
  }
  if (value == 1) {
    str = '发';
  }
  if (value == -1) {
    str = '退';
  }
  if (value == -2) {
    str= '出';
  }
  return str;

});

Vue.filter('deliveryActionName', function (value: any) {
  let str = '';
  if (value == 'PUT') {
    str = '入库';
  }
  if (value == 'RETURN') {
    str = '退货';
  }
  if (value == 'REPLENISH') {
    str = '补货';
  }
  if (value == 'OUT') {
    str = '出库';
  }
  return str;

});

Vue.filter('orderCompanyContractStatus', function (value: any) {
    let str = '';
    if (value == 0) {
        str = '未生成';
    }
    if (value == 1) {
        str = '未提交审核';
    }
    if (value == 2) {
        str = '审核中';
    }
    if (value == 3) {
        str = '审核成功';
    }
    if (value == -1) {
        str = '审核失败';
    }
    if (value == 4) {
        str = '审核成功/已提交签署';
    }
    if (value == 5) {
        str = '审核成功/签署完毕';
    }
    if (value == 6) {
        str = '签署完毕/已生效';
    }
    return str;

});
Vue.filter('moneyConvert', function (n: any) {
    if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
        return '数据非法';
    }
    let unit = '千百拾亿千百拾万千百拾元角分', str = '';
    n += '00';
    const p = n.indexOf('.');
    if (p >= 0) {
        n = n.substring(0, p) + n.substr(p + 1, 2);
    }
    unit = unit.substr(unit.length - n.length);
    for (let i = 0; i < n.length; i++) {
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    }
    return str.replace(/零(千|百|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|壹(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元整');
});

const currencyArray = [{label: '美元', value: 'USD'},
    {label: '元', value: 'RMB'},
    {label: '日元', value: 'JPY'},
    {label: '港元', value: 'HKD'},
    {label: '欧元', value: 'EUR'},
    {label: '英镑', value: 'GBP'},
    {label: '韩元', value: 'KRW'},
    {label: '泰铢', value: 'THB'},
    {label: '印尼盾', value: 'IDR'}];

Vue.filter('currencyZh', function (value: any) {
    let str = '未知';
    for (let i = 0; i < currencyArray.length; i++) {
        if (value == currencyArray[i].value) {
            str = currencyArray[i].label;
        }
    }
    return str;
})
;
Vue.filter('cutWorkerIdName', function (value: any) {
    let str = '';
    if (value == 1||value == '1') {
        str = '拉布';
    }
    if (value == 2||value == '2') {
        str = '裁剪';
    }
    if (value == '3'||value == 3) {
        str = '分包';
    }
    if (value == '4'||value == 4) {
        str = '验片';
    }
    if (value == 5||value == '5') {
        str = '编号';
    }
    return str;

});

export default Vue;
